var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column justify-content-start"},[_c('canvas',{staticClass:"mycanvas car-img",attrs:{"id":"interior","width":"300","height":"448"}})])
}]

export { render, staticRenderFns }